import { Suspense } from "react"
import { SkeletonCardList } from "@/components/shared/loading/card"
import { OpexCategoryCardLinks } from "@/feature/financial-model/ecommerce/opex/components/opex-category-card-links.tsx"

const OpexForecastRoute = () => (
  <Suspense
    fallback={
      <div className="mt-4 space-y-4 w-full">
        <SkeletonCardList num={3} type="card-with-description" />
        <SkeletonCardList num={3} type="card-with-description" />
      </div>
    }
  >
    <div className="mt-4 space-y-4 w-full">
      <OpexCategoryCardLinks period={`forecast`} />
    </div>
  </Suspense>
)

export default OpexForecastRoute
